import React, { useState } from "react";
import { Sheet, SheetContent, SheetDescription, SheetHeader, SheetTitle } from "../../../components/ui/sheet";
import { useProjectAttachments } from "../../../data/project-attachments";
import { useProject } from "../../../data/project";
import Spinner from "../../../components/ui/spinner";
import { AttachmentList } from "./attachment-list";
import { FolderXIcon, PlusIcon } from "lucide-react";
import { Button } from "../../../components/ui/button";
import { CreateAttachmentDialog } from "./create-attachment-dialog";

interface Props {
    open: boolean;
    onOpenChange: (open: boolean) => void;
}

export function AttachmentsDrawer(props: Props) {
    const { uniqueAttachments, isLoading } = useProjectAttachments();
    return (
        <Sheet open={props.open} onOpenChange={props.onOpenChange}>
            <SheetContent className={"flex w-[50svw] flex-col pb-0"}>
                <SheetHeader>
                    <SheetTitle>Attachments</SheetTitle>
                    <SheetDescription>
                        These are all files and links you have attached throughout this project.
                    </SheetDescription>
                </SheetHeader>
                <AddAttachmentButton />
                {isLoading && (
                    <div className={"text-sm font-medium text-muted-foreground"}>
                        <Spinner /> Loading...
                    </div>
                )}
                {uniqueAttachments?.length === 0 && (
                    <div className={"rounded-md border p-8 text-center text-sm font-medium text-muted-foreground"}>
                        <FolderXIcon className={"me-2 inline h-5 w-5"} />
                        There are no attachments for this project.
                    </div>
                )}
                {uniqueAttachments && <AttachmentList attachments={uniqueAttachments} className={"pb-6"} />}
            </SheetContent>
        </Sheet>
    );
}

function AddAttachmentButton() {
    const { project } = useProject();
    const [dialogOpen, setDialogOpen] = useState(false);
    return (
        <CreateAttachmentDialog
            target={["project", project.id]}
            title="Add attachments to project"
            open={dialogOpen}
            onOpenChange={setDialogOpen}
        >
            <Button size="sm" variant="outline-primary" onClick={() => setDialogOpen(true)}>
                <PlusIcon className="me-2 h-5 w-5" /> Add attachment
            </Button>
        </CreateAttachmentDialog>
    );
}
